export default __webpack_public_path__ + "static/media/starter-pack.52dfe867.png";